import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/module',
    name: 'Home',
    component: () => import(/* webpackChunkName: "about" */ '../components/Module.vue')
  },
  {
    path: '/Conocenos',
    name: 'Home',
    component: () => import(/* webpackChunkName: "about" */ '../components/Conocenos.vue')
  },
  

  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
